import { render } from "./NoticeDetail.vue?vue&type=template&id=c1ff4b88&scoped=true"
import script from "./NoticeDetail.vue?vue&type=script&lang=js"
export * from "./NoticeDetail.vue?vue&type=script&lang=js"

import "./NoticeDetail.vue?vue&type=style&index=0&id=c1ff4b88&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1ff4b88"]])

export default __exports__